import * as types from '../mutation_types'
const state = {
  WhenChoices: {
    UNDEF: ['U', '未指定'],
    DAY: ['D', '🌞 白天'],
    FALL: ['F', '🌇  傍晚'],
    NIGHT: ['N', '🌙 夜晚']
  }
}

const getters = {
  WhenChoices: (state) => {
    return state.WhenChoices
  }
}

const actions = {
}

const mutations = {
  [types.SET_USER](state, userinfo) {
    state.nickname = userinfo.nickname
    state.avatar = userinfo.avatar
    state.id = userinfo.id
  },
  [types.UPDATE_USER](state, userinfo) {
    Object.assign(state, userinfo)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/choice.js